
import React from "react";

import { ImageCustom } from '../Image';
import {
  RecognitionBoxCaroussel,
  BoxSize
} from './style';

type RecognitionWrapperProps = {
  imgLink: string;
  imgAlt: string;
  productLink: string;
  props?: any;
};

const vector = 'https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/recognition/Vector.png';

const RecognitionWrapper = ({ imgLink, imgAlt, props }: RecognitionWrapperProps) => {

  return (
      <RecognitionBoxCaroussel>
          <ImageCustom src={imgLink} alt={imgAlt} />
          <BoxSize className="boxsize">
            <ImageCustom src={vector} alt={imgAlt} />
            {imgAlt}
          </BoxSize>
      </RecognitionBoxCaroussel>
  );
}

export default RecognitionWrapper;


